import{jsx as e,jsxs as r,Fragment as t}from"react/jsx-runtime";import{useState as n}from"react";import a from"react-datepicker";import o from"tailwind-styled-components";import l from"dayjs";import{ChevronLeft as i,ChevronsLeft as d,Calendar as s}from"lucide-react";import c from"../input/input.js";import u from"./date-range-input.js";import{twString as m}from"../utils.js";const p=o.div`
  datepicker-container
  inline-flex
  items-center
  relative
  min-w-0

  w-full

  md:w-auto
`,h=o.div`
  flex
  items-center
`,f=o.select`
  appearance-none
  bg-transparent
  cursor-pointer
  flex-grow
  font-bold
  rounded
  text-base
  text-center
  text-white

  hover:bg-white/10
  first:ml-8
  last:mr-8
`,b=o(i)`
  stroke-current
  stroke-1
`,g=o(b)`
  rotate-180
`,x=o(d)`
  stroke-current
  stroke-1
`,y=o(x)`
  rotate-180
`,C=o.button`
  appearance-none
  bg-transparent
  border-none
  cursor-pointer
  inline-flex
  items-center
  p-1
  rounded
  text-white/50

  hover:text-white
  hover:bg-white/10
`,v=m`
  bg-transparent
  border-none
  flex
  flex-col
  rounded
  shadow-lg
  shadow-brand-primary/20
  transition-all
  w-full

  md:flex-row
`,M=(n=1)=>({changeMonth:a,changeYear:o,customHeaderCount:i,date:d,decreaseMonth:s,decreaseYear:c,increaseMonth:u,increaseYear:m,nextMonthButtonDisabled:p,nextYearButtonDisabled:v,prevMonthButtonDisabled:M,prevYearButtonDisabled:w})=>{const Y=Array.from(new Array(12)).map(((e,r)=>l().month(r).format("MMMM"))),D=Array.from(new Array(121)).map(((e,r)=>l().year()-100+r)),k=l(d),N=k.month()+i,z=k.year(),q=e=>r=>{r.stopPropagation(),r.preventDefault(),e(r)};return r(h,{children:[0===i&&r(t,{children:[e(C,{onClick:q(c),disabled:w,title:"Previous Year",children:e(x,{size:14})}),e(C,{onClick:q(s),disabled:M,title:"Previous Month",children:e(b,{size:14})})]}),e(f,{value:Y[N],onChange:({target:{value:e}})=>{a(Y.indexOf(e)-i)},role:"combobox",name:"month",children:Y.map((r=>e("option",{value:r,children:r},r)))}),e(f,{value:z,onChange:({target:{value:e}})=>{o(parseInt(e,10))},role:"combobox",name:"year",children:D.map((r=>e("option",{value:r,children:r},r)))}),(1===i||1===n)&&r(t,{children:[e(C,{onClick:q(u),disabled:p,title:"Next Month",children:e(g,{size:14})}),e(C,{onClick:q(m),disabled:v,title:"Next Year",children:e(y,{size:14})})]})]})},w=({onChange:r,onInvalid:t=(()=>{}),size:o="normal",...i})=>{const[d,u]=n(null),m=e=>{const t=l(e);u(e),"function"==typeof r&&r(e&&t||null,e&&t.format("YYYY-MM-DD")||null)};return e(p,{size:o,children:e(a,{...i,autoComplete:"off",calendarClassName:`${v} ${i.calendarClassName}`,customInput:e(c,{allowClear:!0,className:"md:w-full",onClear:()=>{u(null),m(null)},onInvalid:t,prefix:e(s,{}),required:i.required||!1,size:o}),dateFormat:i.dateFormat||"yyyy-MM-dd",disabledKeyboardNavigation:i.disabledKeyboardNavigation||!0,fixedHeight:!0,onChange:m,placeholderText:i.placeholderText||"Select date",renderCustomHeader:M(1),required:i.required||!1,selected:d})})},Y=({onChange:r,onInvalid:t=(()=>{}),size:o="normal",...i})=>{const[d,s]=n(null),[c,m]=n(null),[h,f]=n(!1),b=e=>{const[t,n]=e,a=l(t),o=l(n);s(t),m(n),"function"==typeof r&&r([t&&a||null,n&&o||null],[t&&a.format("YYYY-MM-DD")||null,n&&o.format("YYYY-MM-DD")||null])};return e(p,{size:o,children:e(a,{...i,autoComplete:"off",calendarClassName:`${v} ${i.calendarClassName} daterange-picker`,customInput:e(u,{$isFocused:h,onClear:()=>{s(null),m(null),b([null,null])},onInvalid:t,required:i.required||!1,size:o}),dayClassName:e=>{const r=l(e);return r.date()===r.daysInMonth()?"react-datepicker__day--last-of-month":""},onCalendarOpen:()=>f(!0),onCalendarClose:()=>f(!1),disabledKeyboardNavigation:!0,dateFormat:"yyyy-MM-dd",endDate:c,fixedHeight:!0,monthsShown:2,onChange:b,renderCustomHeader:M(2),required:i.required||!1,selected:d,selectsRange:!0,startDate:d})})};export{w as DatePicker,Y as DateRangePicker,w as default};
